import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, message, AutoComplete, Button, Tag, Progress } from "antd"
import { cuttingLazeError, getMarkInformation } from '../../../services/api/3dApi'
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

const InputCutLazeError = () => {

    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [error_info, setErrorInfo] = useState('')
    const [items, setItems] = useState([])
    const [listSuccess, setListSuccess] = useState([])
    const [listError, setListError] = useState([])

    const handleShowModal = async (e) => {
        e.preventDefault()

        const checkValue = /^#\d+_\d+$/.test(valueInput)
        if (!checkValue || !valueInput.trim()) return setErrorInput('Item sai định dạng.')

        try {
            const { data: res } = await getMarkInformation(valueInput.trim().replace(/^#/, ''))
            const { data, error, success } = res

            if (!success) return message.error(error)

            const num = valueInput.split('_')[1]
            const itemCutLazed = data.find(i => i.item_number === +num)

            const { batch } = { ...itemCutLazed }
            const { lasers } = { ...batch }

            if (!lasers || !lasers.length) return message.error('Item nằm trong lô chưa được cắt laze.')
            const { finished_at } = { ...lasers[0] }

            if (!finished_at || finished_at === '') return message.error('Item nằm trong lô chưa kết thúc cắt laze.')

            const newItems = [...new Map([...items, { barcode: valueInput }].map(item => [item.barcode, item])).values()]

            if (newItems.length > 100) return message.error("Đánh dấu cắt lỗi tối đa 100 item.")

            setItems(newItems)

        } catch (error) {
            message.error(error.message)
        } finally {
            setValueInput('')
            _input.current.focus()
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const handleChangeError = (value) => {
        setErrorInfo(value)
    }

    const handleCancelModal = () => {
        setIsOpenModal(false)
        setErrorInfo('')
        setListError([])
        setListSuccess([])
        if (!!listSuccess.length || !!listError.length) setItems([])
        _input.current.focus()
    }

    const _onSubmit = async () => {
        setLoading(true)
        setListSuccess([])
        setListError([])

        if (!error_info) {
            setLoading(false)
            return message.error('Cần nhập lý do lỗi')
        }

        try {
            let processed = []

            await Promise.all(items.map(async item => {
                const payload = {
                    barcode: item.barcode.trim() || '',
                    error_info
                }

                const { data: response } = await cuttingLazeError(payload)

                const { success, error } = Object.assign({}, response)

                if (!success) return processed.push({ ...item, error: error, processing: false })
                return processed.push({ ...item, success: true, processing: false })

            }))

            let newListSuccess = []
            let newListError = []

            processed.forEach(process => {
                if (process.success === true) {
                    newListSuccess.push(process)
                }

                if (!!process.error) {
                    newListError.push(process)
                }
            })

            setListSuccess(newListSuccess)
            setListError(newListError)
            setItems(processed)

        } catch (error) {
            message.error(error || error.message)
        } finally {
            setLoading(false)
        }
    }

    const _onSubmitEnter = async (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault()
            _onSubmit()
        }
    }

    const _removeItem = item => {
        setItems(preItems => preItems.filter(i => i.barcode !== item))
    }

    return (
        <div className="site-layout-background pb-4">
            <div className="MarkCuttingError">
                <div className="MarkCuttingErrorPage">
                    <div className="position-relative">
                        <Spin spinning={loading} tip='Đang kiểm tra...'>
                            <form onSubmit={handleShowModal} className="formQC">
                                <Input
                                    value={valueInput.toUpperCase()}
                                    style={{ fontSize: 40, height: "auto" }}
                                    ref={_input}
                                    autoFocus={true}
                                    placeholder='Nhập item cần đánh dấu lỗi'
                                    onChange={_handleChangeScan}
                                />

                                {
                                    valueInput &&
                                    <Icon
                                        type='close-circle'
                                        className="position-absolute cursor-pointer text-dark IconInput"
                                        onClick={_resetScanInput}
                                    />
                                }

                                {
                                    loading &&
                                    <Icon type="sync" spin className="position-absolute IconInput" />
                                }

                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="batch_tag">
                                        {
                                            items.length > 0 &&
                                            items.map((item) => {
                                                return (
                                                    <Tag
                                                        key={item.barcode}
                                                        closable
                                                        onClose={() => _removeItem(item.barcode)}
                                                    >{item.barcode}
                                                    </Tag>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        !!items.length &&
                                        <Button
                                            type='primary'
                                            className='float-right mt-3 px-4'
                                            onClick={() => setIsOpenModal(true)}
                                        >
                                            Đánh dấu cắt lỗi
                                        </Button>
                                    }
                                </div>
                            </form>

                            {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                        </Spin>
                        <Modal
                            title={<h6 className='mb-2'>Đánh dấu cắt lỗi cho {items.length > 1 ? `${items.length} items` : `${items.length} item`}</h6>}
                            visible={isOpenModal} closable
                            onCancel={handleCancelModal}
                            wrapClassName="MarkCuttingErrorModal"
                            footer={[
                                <Button onClick={handleCancelModal}>
                                    Đóng
                                </Button>,
                                <Button
                                    type='primary'
                                    onClick={_onSubmit}
                                    disabled={!!listSuccess.length || !!listError.length}
                                >
                                    Đánh dấu cắt lỗi
                                </Button>
                            ]}
                        >
                            <Spin spinning={loading} tip='Đang kiểm tra...'>
                                <div className='font-weight-bold'>Nhập vào lý do cắt lỗi:</div>
                                <AutoComplete
                                    options={['Cắt hỏng', 'Cắt thiếu']}
                                    dataSource={['Cắt hỏng', 'Cắt thiếu']}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                    }
                                    onChange={handleChangeError}
                                    allowClear
                                    value={error_info}
                                    className='w-100'
                                    maxLength={20}
                                >
                                    <Input.TextArea
                                        placeholder="Nhập lỗi"
                                        style={{ height: 100 }}
                                        onKeyDown={_onSubmitEnter}
                                    />
                                </AutoComplete>

                                {
                                    (listSuccess.length > 0 || listError.length > 0) &&
                                    <div className="Results d-flex align-items-center my-2">
                                        <div className="ResultSuccess mr-2">
                                            Thành công: <span className='text-success font-weight-bold'>{listSuccess.length}</span> lô
                                        </div>
                                        <div className="ResultError">
                                            Thất bại: <span className='text-danger font-weight-bold'>{listError.length}</span> lô
                                        </div>
                                    </div>
                                }
                                <div className="ListProcessing">
                                    <ul>
                                        {
                                            !!items.length && items.map(item => (
                                                <li key={item._id}>
                                                    <span className='mr-2 font-weight-bold'>{item.barcode}</span>
                                                    {
                                                        !!item.error &&
                                                        <span className="Error text-danger"><ExclamationCircleOutlined /> {item.error}</span>
                                                    }
                                                    {
                                                        item.success &&
                                                        <span className="Success text-success"><CheckCircleOutlined /> Thành công</span>
                                                    }
                                                    <Progress
                                                        percent={100}
                                                        size="small"
                                                        status={`${(item.processing === false && item.success === true) ? 'success' : ((item.processing === false && !!item.error) ? 'exception' : 'active')}`}
                                                        showInfo={false}
                                                    />
                                                </li>
                                            )
                                            )
                                        }
                                    </ul>
                                </div>
                            </Spin>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InputCutLazeError